
window.addEventListener('load', function () {
})
